export enum DocType {
  DNI = 'DNI',
  CUIL = 'CUIL',
  CUIT = 'CUIT',
  PAS = 'PAS',
  PREC = 'PREC',
  CDI = 'CDI',
  LC = 'LC',
  LE = 'LE'
};

export const getDocTypeOptions = () => Object.entries(DocType).map(([value, label]) => ({ label, value }))